import LetalkWizardSurveyPage from "@/components/LetalkWizardSurveyPage"
import useDidMount from "@/hooks/useDidMount"
import usePage from "@/hooks/usePage"
import ApiService from "@/services/Api"
import { useGlobalStateStore } from "@/store/GlobalState"
import { externalLinks } from "@/utils/link"
import { SECOND_IN_MS, timeout } from "@/utils/time"
import { Grid } from "@material-ui/core"
import React, { useState } from "react"

const OnboardingLetalkWizard: React.FC = () => {
	const globalStateStore = useGlobalStateStore()
	const page = usePage()

	const [openLetalkWizardSurveyPage, setOpenLetalkWizardSurveyPage] = useState(true)

	const closeMerlin = () => {
		setOpenLetalkWizardSurveyPage(false)
		globalStateStore.setInstanceData({
			merlinData: {
				id: globalStateStore?.instance?.merlinData?.id,
				willShow: false
			}
		})

		page.returnToMainPage()
	}

	useDidMount(() => {
		const shouldOpenOnboarding = globalStateStore?.instance?.merlinData?.willShow || false

		if (shouldOpenOnboarding) {
			globalStateStore.setInstanceData({
				merlinData: {
					id: globalStateStore?.instance?.merlinData?.id,
					willShow: true
				}
			})
		} else {
			page.returnToMainPage()
		}
	})

	return (
		<Grid container>
			<LetalkWizardSurveyPage
				openSurvey={openLetalkWizardSurveyPage}
				letalkWizardUrl={externalLinks.merlinInitialSurvey}
				initVariables={{
					firstName: (globalStateStore?.user?.name?.split(" ")[0]),
					phone: globalStateStore?.user.phone_number,
					email: globalStateStore.user.email,
					isTrial: globalStateStore.instance.subscriptionData?.isTrial,
					startDate: (new Date()),
					instanceId: globalStateStore.instance.instance_id
				}}
				onFormAnswered={async (event) => {
					await ApiService.put(
						`/merlin-interactions/${globalStateStore?.instance?.merlinData?.id}/finish-interaction`,
						{ userAnswered: event.data.params }
					)
					closeMerlin()
				}}
				onLetalkWizardInit={async () => {
					await timeout(5 * SECOND_IN_MS)
				}}
				onError={closeMerlin}
			>
			</LetalkWizardSurveyPage>
		</Grid>
	)
}

export default OnboardingLetalkWizard
